'use client';

import { useEffect } from 'react';
import { capture } from '@/lib/analytics/posthog';
import { useTrackEventView, useTrackNewsView } from '@/lib/hooks/useAnalyticsTracker';

interface EventTrackerProps {
  id: string;
  /** Event title shown to the user (snapshotted for analytics). */
  title?: string;
  /** Viewer country; when omitted it is resolved client-side. */
  country?: string;
}

interface NewsTrackerProps {
  id: string;
  /** News title in the viewed language. */
  title?: string;
  /** Strapi locale (`lc`) of the viewed entry. */
  locale?: string;
  /** Strapi documentId (`di`), shared across all language versions. */
  documentId?: string;
  /** Viewer country; when omitted it is resolved client-side. */
  country?: string;
}

export function EventViewTracker({ id, title, country }: EventTrackerProps) {
  useTrackEventView(id, { title, country });

  // The PostHog counterpart of the in-house event-view: one per page open, keyed
  // on the market so the trading funnel starts from a market rather than a URL.
  useEffect(() => {
    capture('market_viewed', { event_id: id, title });
  }, [id, title]);

  return null;
}

export function NewsViewTracker({ id, title, locale, documentId, country }: NewsTrackerProps) {
  useTrackNewsView(id, { title, locale, documentId, country });
  return null;
}
